import * as React from 'react';

export const PaperPlaneSVG: JSX.Element =
  <svg width="134" height="134" viewBox="0 0 134 134" className="cmp-paper-plane">
    <g transform="translate(1 1.621)"><line x1="81.41" y2="81.41" transform="translate(48.223 0.5)" /><path d="M73.488,129.633,48.223,81.91.5,56.645,129.633.5Z" /></g>
  </svg>



export default PaperPlaneSVG;
